import React from "react";
import { graphql } from "gatsby";
import { Video as VideoComponent } from "@zempler/theme/src/components/video/Video";

export const Video = ({ data, ...rest }) => (
  <VideoComponent {...data} overlayImage={data?.image?.image?.localFile} />
);

export const VideoQuery = graphql`
  fragment Video on UMBRACO_VideoComponentType {
    title
    url
    image {
      image {
        ...VideoImage
      }
    }
  }
`;
